import { createMappedEntityAdapter, type MappedEntityAdapter, type MappedEntityState } from '@/utils/store/store-map.utils';
import type { Attribute } from '../../../interfaces/Attribute.interface';

export enum MapKey {
    BY_CATEGORY_ID = 'byCategoryId'
}

export const attributeAdapter: MappedEntityAdapter<Attribute, MapKey> = createMappedEntityAdapter({
    selectId: attribute => attribute.attributeId,
    mapDefinitions: [{ selectMapId: attribute => attribute.categoryId, mapName: MapKey.BY_CATEGORY_ID }],
    sortComparer: (a1, a2) => a1.rank - a2.rank
});

export interface State extends MappedEntityState<Attribute> {
    isPending: boolean;
    isLoaded: boolean;
}

export const initialState: State = attributeAdapter.getInitialState({
    isPending: false,
    isLoaded: false
});
